import React from 'react';
import { Link } from 'react-router-dom';

interface LayoutProps {
  currentPage: string;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ currentPage, children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <header className="bg-blue-600 text-white p-4">
        <h1 className="text-2xl">After Them - {currentPage}</h1>
      </header>
      <div className="flex flex-grow overflow-hidden">
        <nav className="w-64 bg-gray-200 p-4">
          <ul>
            <li><Link to="/" className="text-blue-600 hover:underline">Map</Link></li>
            <li><Link to="/eidogen" className="text-blue-600 hover:underline">Eidogen</Link></li>
            <li><Link to="/eidonomicon" className="text-blue-600 hover:underline">Eidonomicon</Link></li>
            <li><Link to="/encryptids" className="text-blue-600 hover:underline">Encryptids</Link></li>
          </ul>
        </nav>
        <main className="flex-grow p-4 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;